import React, { useEffect, useState } from 'react';
import MailInbox from '../../Moecules/mail-page/inbox/MailInbox';
import MailTemplateSent from '../../Moecules/mail-page/email-sent/MailTemplateSent';
import styles from './MailPage.module.scss';
import WrappingContainer from '../../HOC/WrappingContainer/WrappingContainer';
import SendMailContainer from '../../Moecules/mail-page/send-email/SendMailContainer';
import { useDeleteMail } from '../../../Hooks/Mail';
import { toast } from 'react-toastify';
import DeletePopup from '../../Moecules/Custom/DeletePopup';
const MailPage = () => {
  const [selectedMail, setSelectedMail] = useState(null);
  const [isNewMail, setIsNewMail] = useState(false);
  const [mailsType, setMailsType] = useState('Inbox');
  const [refresh, setRefresh] = useState(false);
  const [isDelete, setIsDelete] = useState({
    id: null,
    show: false,
  });
  const [reply, setReply] = useState({
    show: false,
    type: null,
    content: null,
  });

  const { mutate: DeleteMail, isLoading } = useDeleteMail();

  const onDelete = (id) => {
    setIsDelete((prev) => ({
      ...prev,
      id: id,
      show: true,
    }));
  };

  const handleDelete = () => {
    DeleteMail(isDelete.id, {
      onSuccess: () => {
        if (isDelete.id === selectedMail?.id) {
          setSelectedMail(null);
        }
        setRefresh(true);
        setIsDelete({
          id: null,
          show: false,
        });
        toast.success('Mail Deleted successfully');
      },
    });
  };

  useEffect(() => {
    if (refresh) {
      const timer = setTimeout(() => setRefresh(false), 800);
      return () => clearTimeout(timer);
    }
  }, [refresh]);

  return (
    <>
      <WrappingContainer className={styles['mailContainer']}>
        <MailInbox
          setSelectedMail={setSelectedMail}
          setIsNewMail={setIsNewMail}
          isNewMail={isNewMail}
          selectedMail={selectedMail}
          refresh={refresh}
          setRefresh={setRefresh}
          onDelete={onDelete}
          mailsType={mailsType}
          setMailsType={setMailsType}
        />
        <MailTemplateSent
          selectedMail={selectedMail}
          setReply={setReply}
          setIsNewMail={setIsNewMail}
          onDelete={onDelete}
          setRefresh={setRefresh}
        />
      </WrappingContainer>
      <SendMailContainer
        isNewMail={isNewMail}
        setIsNewMail={setIsNewMail}
        setRefresh={setRefresh}
        reply={reply}
        setReply={setReply}
        mailsType={mailsType}
      />
      {isDelete?.show && (
        <DeletePopup
          handleOnClose={() =>
            setIsDelete((prev) => ({
              ...prev,
              show: false,
            }))
          }
          title='Mail'
          handleDelete={handleDelete}
          isLoading={isLoading}
        />
      )}
    </>
  );
};

export default MailPage;
